import * as tslib_1 from "tslib";
import * as React from 'react';
var style = {
    borderRadius: '3px',
    padding: '.2rem',
    color: 'white',
    fontSize: '11px'
};
var Badge = function (props) { return (React.createElement("div", { className: "badge", style: tslib_1.__assign({}, style, props.styleOverride, { backgroundColor: props.color }) }, props.children)); };
export default Badge;



//////////////////
// WEBPACK FOOTER
// ./src/components/Badge.tsx
// module id = 119
// module chunks = 0